import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import styled from "@emotion/styled";
import { SystemConstant } from "@/const";

export const ButtonStatusUser = styled(Button)({
  width: 180,
  maxWidth: "100%",
});

export type StatusRequestProps = {
  status: SystemConstant.STATUS_REQUEST;
};

export type ButtonStatusType =
  | {
      color: "primary" | "success" | "error" | "warning";
      label: string;
    }
  | undefined;

const StatusInternalRequest: FC<StatusRequestProps> = ({ status }) => {
  const { t: getLabel } = useTranslation();

  const [btnStatus, setBtnStatus] = useState<ButtonStatusType>();

  useEffect(() => {
    switch (status) {
      case SystemConstant.STATUS_REQUEST.approvedSendingData:
        setBtnStatus({
          color: "primary",
          label: getLabel("OBJ_STATUS_REQUEST.created"),
        });
        break;

      case SystemConstant.STATUS_REQUEST.success:
        setBtnStatus({
          color: "success",
          label: getLabel("OBJ_STATUS_REQUEST.success"),
        });
        break;

      case SystemConstant.STATUS_REQUEST.failed:
        setBtnStatus({
          color: "error",
          label: getLabel("OBJ_STATUS_REQUEST.failed"),
        });
        break;

      default: // TODO: Other status is processing at Ver0.3
        setBtnStatus({
          color: "warning",
          label: getLabel("OBJ_STATUS_REQUEST.processing"),
        });
        break;
    }
  }, [status]);

  return (
    btnStatus && (
      <ButtonStatusUser variant="outlined" color={btnStatus.color} disableRipple>
        {btnStatus.label}
      </ButtonStatusUser>
    )
  );
};

export default StatusInternalRequest;
